// Shared light/dark theme plumbing.
//
// The theme is applied by setting `data-theme` on <html> (index.css defines the
// token overrides for `:root[data-theme="dark"]`) and is persisted to
// localStorage so a reload — or a deep-link straight to a sub-page that doesn't
// mount the main App — still renders in the user's chosen theme.

export type ThemeMode = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'searchx:theme';

export function isThemeMode(value: unknown): value is ThemeMode {
  return value === 'light' || value === 'dark';
}

export function readStoredTheme(): ThemeMode {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (isThemeMode(stored)) return stored;
  } catch { /* localStorage unavailable */ }
  return 'light';
}

// Drive the DOM + persist. Safe to call on mount of any route so the page
// reflects the stored theme even when the main App never mounted.
export function applyTheme(theme: ThemeMode): void {
  document.documentElement.dataset.theme = theme;
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch { /* localStorage unavailable; in-memory state still drives the DOM */ }
}
